export * from './coffee-trader';
export * from './inventory-item';
export * from './order';
export * from './order-details';
export * from './tab';
export * from './supplier'
export * from './rms-table';
export * from './purchase-order.interface';
export * from './inventory.interface';
export * from './prompt.interface';
export * from './filters.interface'
export * from './utils.interface';
export * from './inbound-tally.interface';

export function formatDiffAllowZero(value: number | null): string {
  const safeValue = value ?? 0;

  return safeValue
    .toFixed(2)
    .replace(/^0\./, '.')
    .replace(/^-0\./, '-.');
}

export function formatCPriceDisplay(value: number | null): string {
  return `'C' +${formatDiffAllowZero(value)}`;
}
export function formatCurrencyDisplay(value: number | null): string {
  return `$${(value ?? 0).toFixed(2)}`;
}
